import * as React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

import {
    Button,
    // TextField,
    Checkbox,
    Theme as ITheme,
    WithStyles as IWithStyles,
    FormControl,
    Select,
    MenuItem,
    // Typography,
     InputLabel,
} from '@material-ui/core';
import { IRegisterForm } from './types';

const styles = (theme: ITheme) => ({
    card: {
        background: '#FFFFFF',
        boxShadow: '0px 3px 12px #00000012',
        borderRadius: '20px',
        maxWidth: '600px',
        padding: '80px',
        [theme.breakpoints.down('lg')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '47px 32px',
        },
        textAlign: 'center' as 'center',
    },
    heading: {
        fonFamily: 'League Spartan',
        fontWeight: 500,
        fontSize: '32px',
        lineHeight: '38px',
        textTransform: 'uppercase' as 'uppercase',
        marginBotom: '56px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
        },
    },
    field: {
        width: '100%',
        marginTop: '20px',
        borderRadius: '0px',
        '& div': {
            borderRadius: '0px',
        },
        '& input': {
            background: '#fff',
            color: '#000',
            borderRadius: '0px',
        },
    },
    text: {
        marginTop: '20px',
        color: 'white',
    },
    formControl: {
        minWidth: 120,

        '& .MuiSelect-root': {
            borderBottom: '1px solid black',
            paddingBottom: '2px',
            color: 'black',

            maxWidth: '200px',
            textAlign: 'left' as 'left', // optional: add some padding to prevent the text from touching the border
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 12px)',
            color: 'black', // center the arrow vertically
        },
    },
    greeting: {
        color: '#fff',
        fontSize: '1em',
        width: '120%',
        marginBottom: '10px',
        fontWeight: 100,
    },
    submitBtn: {
        fontWeight: 500,
        background: '#EF0017',
        textTransform: 'none' as 'none',
        borderRadius: '24px',
        fontFamily: 'Poppins',
        color: 'white',
        fontSize: '14px',
        lineHeight: '18px',
        padding: '12px 24px',
        width: '102px',
        boxSize: 'borderBox',
        height: '48px',
        [theme.breakpoints.down('xs')]: {
            height: '32px',
            padding: '8px 16px',
            width: '100px',
        },
        '&:disabled': {
            background: '#cccccc',
            color: '#666666',
        },
    },
    errorLabel: {
        marginBottom: '10px',
    },
    submitBtnWrapper: {
        marginTop: '30px',
        textAlign: 'center' as 'center',
    },
    message: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontFamily: 'Poppins',
        fontSize: '14px',
        lineHeight: '18px',
        marginTop: '24px',
    },
    link: {
        color: '#EF0017',
        textDecoration: 'none',
        paddingLeft: '4px',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    emailOptIn: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        fontSize: '14px',
        fontFamily: 'Poppins',
        textAlign: 'left' as 'left',
        fontWeight: 400,
    },
    textField: {
        width: '100%',
        display: 'flex',
        aligItems: 'flex-start',
        flexDirection: 'column' as 'column',
        marginBottom: '40px',
        '&:last-child': {
            marginBottom: '0px',
        },
    },

    labelField: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left' as 'left',
        fontWeight: 500,
        maxWidth: '210px',
        wordWrap: 'break-word' as 'break-word',
    },
    inputField: {
        border: 'none',
        borderBottom: '1px solid black',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    inputFieldError: {
        border: 'none',
        borderBottom: '1px solid red',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    formWrapper: {
        marginTop: '24px',
        padding: '0px',
    },
    inputWrapper: {
        display: 'grid',
        [theme.breakpoints.down('lg')]: {
            gap: '16px',
        },
        [theme.breakpoints.down('md')]: {
            gap: '16px',
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
            gap: '0px',
            marginBottom: '40px',
        },
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
            gap: '0px',
            marginBottom: '40px',
        },
        gridTemplateColumns: '1fr 1fr',
    },
    dropdownWrapper: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        width: '100%',
    },
    termsWrapper: {
        marginTop: '40px',
        display: 'flex',
        flexDirection: 'column' as 'column',
        marginLeft: '-11px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
    },
    footer: {
        marginTop: '20px',
        textAlign: 'center' as 'center',
        maxWidth: '300px',
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontStyle: 'italic',
        marginBottom: '60px',
    },
    cardOuterWrapper: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    trailText: {
        fontFamily: 'Poppins',
        fontWeight: 600,
        marginBottom: '16px',
    },
});

interface IProps extends IWithStyles {
    onSubmit: (method: string) => void;
    form: IRegisterForm;
    onChange: (
        form: 'login' | 'register',
        field: string
    ) => (e: React.ChangeEvent<HTMLInputElement>) => void;

    emailIsInvalid: (form: 'login' | 'register') => boolean;
    formIsDisabled: (form: 'login' | 'register') => boolean;
}

export const registerBox = ({
    classes,
    form,
    onChange,
    onSubmit,
    emailIsInvalid,
    formIsDisabled,
}: IProps) => {
    const handleChange = (a: any, b: any, e: any, r: any) => {
        const register = onChange('register', 'phone');
        return register(e);
    };
    // const [phone, setPhone] = React.useState(form.phone);
    return (
        <div className={classes.cardOuterWrapper}>
            <div className={classes.card}>
                <div className={classes.heading}>SIGN UP</div>
                <form className={classes.formWrapper}>
                    <div className={classes.inputWrapper}>
                        <div
                            className={classes.textField}
                            style={{ marginBottom: '40px' }}
                        >
                            <div className={classes.labelField}>First Name</div>
                            <input
                                className={
                                    form.errors.state
                                        ? classes.inputFieldError
                                        : classes.inputField
                                }
                                autoComplete='off'
                                required={true}
                                id='firstName'
                                onChange={onChange('register', 'firstName')}
                                value={form.firstName}
                                placeholder='First name'
                            ></input>
                        </div>
                        <div
                            className={classes.textField}
                            style={{ marginBottom: '0px' }}
                        >
                            <div className={classes.labelField}>Last Name</div>
                            <input
                                className={
                                    form.errors.state
                                        ? classes.inputFieldError
                                        : classes.inputField
                                }
                                autoComplete='off'
                                required={true}
                                id='lastName'
                                onChange={onChange('register', 'lastName')}
                                value={form.lastName}
                                placeholder='Last name'
                            ></input>
                        </div>
                    </div>

                    <div className={classes.textField}>
                        <div className={classes.labelField}>
                            Orgnisation Name
                        </div>
                        <input
                            className={
                                form.errors.state
                                    ? classes.inputFieldError
                                    : classes.inputField
                            }
                            autoComplete='off'
                            required={true}
                            id='organizationName'
                            onChange={onChange('register', 'organizationName')}
                            value={form.organizationName}
                            placeholder='Organization name'
                        ></input>
                    </div>

                    <div className={classes.textField}>
                        <div className={classes.labelField}>Email</div>
                        <input
                            className={
                                form.errors.state || emailIsInvalid('register')
                                    ? classes.inputFieldError
                                    : classes.inputField
                            }
                            autoComplete='off'
                            required={true}
                            id='email'
                            onChange={onChange('register', 'email')}
                            value={form.email}
                            placeholder='Email *'
                        ></input>
                    </div>
                    <div className={classes.textField}>
                        <div className={classes.labelField}>Password</div>
                        <input
                            className={
                                form.errors.state
                                    ? classes.inputFieldError
                                    : classes.inputField
                            }
                            autoComplete='off'
                            required={true}
                            type='password'
                            id='password'
                            onChange={onChange('register', 'password')}
                            value={form.password}
                            placeholder='Password *'
                        ></input>
                    </div>
                    <div className={classes.textField}>
                        <div className={classes.labelField}>Number</div>
                        <PhoneInput
                            fullWidth
                            placeholder='Phone number'
                            id='phone'
                            value={form.phone}
                            onChange={handleChange}
                            inputStyle={{
                                borderRadius: 0,
                                marginTop: '4px',
                                width: '100%',
                                border: 'none',
                                borderBottom: '1px solid black',
                            }}
                            buttonStyle={{
                                marginTop: '4px',
                            }}
                            country={'us'}
                            specialLabel=''
                            error={form.errors.state}
                            inputProps={{
                                name: 'phone',
                            }}
                        />
                    </div>
                    <div className={classes.inputWrapper}>
                        <div
                            className={classes.dropdownWrapper}
                            style={{ marginBottom: '40px' }}
                        >
                            <div className={classes.labelField}>
                                Had you heard of telestration before Keyframe ?
                            </div>
                            <FormControl className={classes.formControl}>
                                <Select
                                    id='telestrated'
                                    value={form.telestrated.select}
                                    onChange={onChange('register', 'telestrated')}
                                    name='select'
                                >
                                    <MenuItem value='yes'>Yes</MenuItem>
                                    <MenuItem value='no'>No</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ marginBottom: '0px' }}>
                            <div className={classes.dropdownWrapper}>
                                <div className={classes.labelField}>
                                    Where did you hear about Keyframe Sports?
                                </div>
                                <FormControl className={classes.formControl}>
                                    <Select
                                        id='referral-source'
                                        value={form['referral-source'].select}
                                        onChange={onChange(
                                            'register',
                                            'referral-source'
                                        )}
                                        name='select'
                                        style={{
                                            color: 'black',
                                        }}
                                    >
                                        <MenuItem value='twitter'>
                                            Twitter
                                        </MenuItem>
                                        <MenuItem value='facebook'>
                                            Facebook
                                        </MenuItem>
                                        <MenuItem value='instagram'>
                                            Instagram
                                        </MenuItem>
                                        <MenuItem value='youtube'>
                                            Youtube
                                        </MenuItem>
                                        <MenuItem value='search-engine'>
                                            Search engine (Google etc)
                                        </MenuItem>
                                        <MenuItem value='word-of-mouth'>
                                            Word of mouth
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    <div className={classes.termsWrapper}>
                        <span className={classes.emailOptIn}>
                            <Checkbox
                                checked={form.emailOptIn}
                                style={{
                                    color: 'black',
                                }}
                                onChange={onChange('register', 'emailOptIn')}
                            />
                            <span>Receive emails from Keyframe</span>
                        </span>
                        <span className={classes.emailOptIn}>
                            <Checkbox
                                checked={form.agreeToTerms}
                                style={{
                                    color: 'black',
                                }}
                                onChange={onChange('register', 'agreeToTerms')}
                            />
                            <div style={{ wordWrap: 'break-word' }}>
                                I agree to the &nbsp;
                                <a
                                    style={{ paddingLeft: '0px' }}
                                    className={classes.link}
                                    href='https://www.keyframesports.com/files/Terms%20and%20Conditions%20Keyframe.pdf'
                                >
                                    terms of service
                                </a>
                            </div>
                        </span>
                    </div>

                    <div className={classes.submitBtnWrapper}>
                    <InputLabel
                    error={form.errors.state}
                                    className={classes.errorLabel}
                                    >
                        {form.errors.serverErrors}
                    </InputLabel> 
                        <Button
                            disabled={formIsDisabled('register')}
                            variant='contained'
                            color='primary'
                            onClick={() => onSubmit('register')}
                            className={classes.submitBtn}
                        >
                            Sign Up
                        </Button>
                    </div>
                    <div className={classes.message}>
                        <span>Already have login and password?</span>
                        <Link to='/login' className={classes.link}>
                            Sign in
                        </Link>
                    </div>
                </form>
            </div>
            <div className={classes.footer}>
                <div className={classes.trailText}>*Free 14 day trial</div>
                **Please note that phone verification is required for signup.
                Your number will only be used to verify your identity for
                security purposes.
            </div>
        </div>
    );
};

export const RegisterBox = withStyles(styles)(registerBox);



// WEBPACK FOOTER //
// ./src/Features/UserManagement/components/RegisterBox.tsx